import { TrustindexWidget } from "@/components/TrustindexWidget";

export function ClientReviews() {
  return (
    <section className="section-padding-sm bg-background overflow-hidden">
      <div className="container-wide mb-10">
        <p className="text-small uppercase tracking-widest mb-4 text-center">
          Vertrouwd door
        </p>
        <h2 className="text-center text-2xl md:text-3xl">
          Wat klanten zeggen
        </h2>
      </div>
      <div className="container-wide">
        <TrustindexWidget loaderId="6459b1064faf406abe3651d1c3a" />
      </div>
    </section>
  );
}
